import { useEffect } from "react";
import useRecorderContext from "../context/useRecorderContext";
import type { CanvasBackground } from "../backgrounds/canvasBackgrounds";
import logger from "../utils/logger";

const useCanvasBackground = (background?: CanvasBackground) => {
  const { setBackgroundImage, setBackgroundColor } = useRecorderContext();

  useEffect(() => {
    if (!background) return;

    // Debug logging disabled to reduce console bloat

    // Reset all
    setBackgroundImage(null);
    setBackgroundColor(null);

    if (background.type === "image" && background.src) {
      const img = new Image();
      img.src = background.src;
      img.onload = () => {
        // Debug logging disabled to reduce console bloat
        setBackgroundImage(img);
      };
      img.onerror = () => {
        logger.error(
          "useCanvasBackground: Failed to load image",
          background.src
        );
      };
    }

    if (
      (background.type === "color" || background.type === "gradient") &&
      background.color
    ) {
      // Debug logging disabled to reduce console bloat
      setBackgroundColor(background.color);
    }
  }, [background, setBackgroundImage, setBackgroundColor]);
};

export default useCanvasBackground;
